import { DEFAULT_PAGE_SIZE, PAGE_SIZES, SORT_KEYS } from '../constants/announcement';
import type { ITableSettings } from '../types/announcement';

/**
 * Table settings kept like pfm keeps its table (page size, sorting). pfm stores them through the ZennoBrowser
 * agent, which the admin in UA2 cannot reach, so they are kept in this browser; storage blocked = defaults.
 */
const SETTINGS_KEY = 'zbAdmin.announcements.table';

export const readTableSettings = (): ITableSettings => {
  try {
    const raw = JSON.parse(localStorage.getItem(SETTINGS_KEY) ?? '{}') as Partial<ITableSettings>;
    const sort =
      raw.sort && SORT_KEYS.includes(raw.sort.key) && (raw.sort.order === 'ascend' || raw.sort.order === 'descend')
        ? raw.sort
        : undefined;
    return { pageSize: PAGE_SIZES.includes(Number(raw.pageSize)) ? Number(raw.pageSize) : DEFAULT_PAGE_SIZE, sort };
  } catch {
    return { pageSize: DEFAULT_PAGE_SIZE, sort: undefined };
  }
};

export const writeTableSettings = (settings: ITableSettings): void => {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch {
    // Storage blocked: the settings last until the reload.
  }
};
